/*
 * File: product.service.ts                                                    *
 * Project: catalog-cloud                                                      *
 * File Created: Thursday, 17th February 2022 11:48:25                         *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Monday, 6th March 2023 10:04:14                              *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import {
  Injectable,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
} from '@angular/core';

import { BehaviorSubject, firstValueFrom, Observable, Subject } from 'rxjs';
import { filter } from 'smart-array-filter';
import { keyValue } from '../../tms-tools/interfaces/key-value';
import { Product } from '@nousmedis/cc-types';
import { ApiParam, ApiParams } from '../../api/models/api-param.model';
import { ApiService } from '../../api/services/api.service';
import { ItemDropInterface } from '../interfaces/item-drop.interface';
import { ProductDragPreviewComponent } from '../components/product/product-drag-preview/product-drag-preview.component';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private draggedItem: ItemDropInterface;

  private _LIMIT_SEARCH: number = 100;

  offsetSearch: number = 0;
  private get urlBase(): string { return this.api.getBaseUrl(); }

  get endPoints(): { products: string; search: string; countSearch: string } {
    return {
      products: this.urlBase + '/api/v1/products',
      search: this.urlBase + '/api/v1/products/search/',
      countSearch: this.urlBase + '/api/v1/products/countsearch/',
    };
  }

  get endPoint(): string { return this.urlBase + '/api/v1/products'; }

  addProduct$: Subject<string> = new Subject<string>();
  removeProduct$: Subject<string> = new Subject<string>();
  viewDetails: Subject<any> = new Subject<any>();
  searchScrollHandler: Subject<boolean> = new Subject<boolean>();
  orderHandler: Subject<string> = new Subject<string>();
  showProductDetailsWindow$ = new BehaviorSubject<boolean>(false);
  totalProductList$: Subject<number> = new Subject<number>();
  productList$: Subject<Product[]> = new Subject<Product[]>();
  lazyLoadProducts$: Subject<Product[]> = new Subject<Product[]>();

  refreshProducts$: Subject<void> = new Subject<void>();

  productDetails$: Subject<Product> = new Subject<Product>();

  private showProductDetailsWindow: boolean = false;

  dropToListHandler: Subject<ItemDropInterface> =
    new Subject<ItemDropInterface>();

  private droppedProductToList: ItemDropInterface;

  currentSearch = {
    idCatalog: '',
    filter: [] as keyValue[],
    searchTerms: [] as string[],
    order: '',
    skip: 0,
    condition: 'AND',
  };

  constructor (
    private api: ApiService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) { }


  

  countProducts(idCatalog: string, categories: string[], tags: string[]) {
    let url = this.endPoint + '/count/' + idCatalog;
    let paramCat = new ApiParam('categories', categories);
    let paramTag = new ApiParam('tags', tags);

    let params: ApiParams = new ApiParams();
    params.params.push(paramCat, paramTag);
    return this.api.get(url, params);
  }

  getProducts(idCatalog: string, filter: keyValue[]) {
    let url = this.endPoint + '/filter/' + idCatalog;
    let params: ApiParams = new ApiParams();
    for (let i = 0; i < filter.length; i++) {
      let param = new ApiParam(filter[i].id, filter[i].value);
      params.params.push(param);
    }
    return this.api.get(url, params);
  }

  getProduct(idCatalog: string, idProduct: string) {
    if (idProduct == null || idProduct == undefined) {
      return undefined;
    }
    let url = this.endPoint + '/' + idProduct + '/catalog/' + idCatalog;
    return this.api.get(url);
  }

  getAddedProducts(idCatalog: string, idFascicle: string) {
    let url =
      this.endPoint +
      '/added-products/catalog/' +
      idCatalog +
      '/fascicle/' +
      idFascicle;
    return this.api.get(url);
  }

  countSearchProducts(
    idCatalog: string,
    filter: keyValue[],
    searchTerms: string[]
  ) {
    let url = this.endPoints.search + idCatalog;
    let body = {};
    for (let i = 0; i < filter.length; i++) {
      if (filter[i].id == 'categories')
        Object.assign(body, { categories: filter[i].value });
      if (filter[i].id == 'tags')
        Object.assign(body, { tags: filter[i].value });
    }
    Object.assign(body, { searchTerms: searchTerms });
    return this.api.post(url, body);
  }

  setSearch(
    idCatalog: string,
    filter: keyValue[],
    searchTerms: string[],
    order: string,
    condition: 'AND' | 'OR'
  ) {
    this.currentSearch.idCatalog = idCatalog;
    this.currentSearch.filter = filter;
    this.currentSearch.searchTerms = searchTerms;
    this.currentSearch.order = order;
    this.currentSearch.condition = condition;
  }

  //TODO PARA PROXIMAS RELEASES
  // CUANDO SE PUEDA ESCOGER o FILTRAR A TIEMPOR REAL POR LAS CATEGORIAS O TAGS
  private mergeSearch(
    currentTags: string[],
    currentCategories: string[],
    baseTags: string[],
    baseCategories: string[]
  ) {
    let body: any;

    for (let i = 0; i < filter.length; i++) {
      if (this.currentSearch.filter[i].id == 'categories')
        console.log(this.currentSearch.filter[i].value);

      if (this.currentSearch.filter[i].id == 'tags')
        console.log(this.currentSearch.filter[i].value);
    }
    return {};
  }

  postSearchProducts(fascicleTags: string[], fascicleCategories: string[]) {
    if (!this.currentSearch.idCatalog) return;
    let url = this.endPoints.search + this.currentSearch.idCatalog;
    let body = {};
    this.offsetSearch = 0;

    // for (let i = 0; i < filter.length; i++) {
    //   if (this.currentSearch.filter[i].id == 'categories')
    //     //Object.assign(body, { categories: this.currentSearch.filter[i].value });
    //     currentCats.push(this.currentSearch.filter[i].value);

    //   if (this.currentSearch.filter[i].id == 'tags')
    //     currentTags.push(this.currentSearch.filter[i].value)
    //     //Object.assign(body, { tags: this.currentSearch.filter[i].value });
    // }
    Object.assign(body, { tags: fascicleTags });
    Object.assign(body, { categories: fascicleCategories });
    Object.assign(body, { order: this.currentSearch.order });
    Object.assign(body, { searchTerms: this.currentSearch.searchTerms });
    Object.assign(body, { conditionType: this.currentSearch.condition });
    Object.assign(body, { limit: this._LIMIT_SEARCH });
    Object.assign(body, { skip: this.offsetSearch });
    firstValueFrom(this.api.post(url, body)).then((data) => {
      this.productList$.next(data.products);
      this.totalProductList$.next(data.totaldocs);
      this.offsetSearchIncrement();
    });
  }

  lazyLoadSearchProducts(fascicleTags: string[], fascicleCategories: string[]) {
    let url = this.endPoints.search + this.currentSearch.idCatalog;
    let body = {};

    Object.assign(body, { tags: fascicleTags });
    Object.assign(body, { categories: fascicleCategories });
    Object.assign(body, { order: this.currentSearch.order });
    Object.assign(body, { searchTerms: this.currentSearch.searchTerms });
    Object.assign(body, { limit: this._LIMIT_SEARCH });
    Object.assign(body, { skip: this.offsetSearch });
    firstValueFrom(this.api.post(url, body)).then((data) => {
      this.lazyLoadProducts$.next(data.products);
      this.offsetSearchIncrement();
    });
  }

  offsetSearchIncrement() {
    this.offsetSearch = this.offsetSearch + this._LIMIT_SEARCH;
  }

  addVersion(idCatalog: string, product: Product) {
    return this.api.post(this.endPoint + '/addVersion/' + idCatalog, product);
  }

  selectedProduct(item: any) {
    this.viewDetails.next(item);
  }

  getOffset() {
    return this.offsetSearch;
  }

  getAllProperties(products: Product[]): any {
    let properties: any = [];
    products.forEach((product) => {
      let productKeys = Object.keys(product);
      productKeys.forEach((key) => {
        properties.indexOf(key) === -1 ? properties.push(key) : null;
      });
    });
    return properties;
  }

  addBaseToVariant(product: Product) {
    if (product.variants.length > 0) {
    }
  }

  isShowProductDetails(): Observable<boolean> {
    return this.showProductDetailsWindow$.asObservable();
  }

  setShowProductsDetails(show: boolean): void {
    this.showProductDetailsWindow$.next(show);
  }

  //añadir funciones drag y drop
  dragProduct(item: ItemDropInterface) {
    this.draggedItem = item;
  }

  dropProduct(): ItemDropInterface {
    return this.draggedItem;
  }

  setDroppedProductToList(id: ItemDropInterface) {
    this.droppedProductToList = id;
  }

  getDroppedProductToList() {
    return this.droppedProductToList;
  }

  setPreviewStyle(event: DragEvent, dragPreview: HTMLElement, item: Product) {
    // Crear un contenedor para el componente
    const container = document.createElement('div');
    container.style.position = 'absolute';
    container.style.top = '-9999px'; // Ocultar fuera de la pantalla

    // Crear el componente dinámicamente
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      ProductDragPreviewComponent
    );
    const componentRef = factory.create(this.injector);

    // Pasar el producto como entrada al componente
    componentRef.instance.item = item;

    // Adjuntar el componente al DOM
    this.appRef.attachView(componentRef.hostView);
    container.appendChild((componentRef.hostView as any).rootNodes[0]);
    document.body.appendChild(container);

    // Usar el contenedor como drag preview
    event.dataTransfer?.setDragImage(container, 100, 75);

    // Eliminar el contenedor después de un tiempo
    setTimeout(() => {
      this.appRef.detachView(componentRef.hostView);
      document.body.removeChild(container);
    }, 0);
  }
}
